import React from "react";

function FamilyGetaways() {
  return (
    <div className="page-container">
      <h2>👨‍👩‍👧 Family Getaways</h2>
      <p>
        Create lasting memories with family-friendly destinations, designed for
        comfort and togetherness.
      </p>
      <p>
        ✅ Singapore – clean, safe & fun for kids with theme parks  
        ✅ Paris – culture, history, and family-friendly attractions  
        ✅ Kerala, India – houseboats, backwaters, and warm hospitality
      </p>
      <p>
        Our family getaways ensure safety, relaxation, and fun for all age
        groups!
      </p>
      <img
        src="https://images.unsplash.com/photo-1529070538774-1843cb3265df"
        alt="Family travel"
        style={{ width: "100%", borderRadius: "12px", marginTop: "20px" }}
      />
    </div>
  );
}

export default FamilyGetaways;
